// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d77509fc","455":"8c3f7dd2","977":"43392031"}[chunkId] + ".chunk.js";
};